import { useMutation } from 'react-query';
import Cookies from 'universal-cookie';
import {
  forgotPasswordEndpoint,
  loginEndpoint,
  logoutEndpoint,
  resetPasswordEndpoint,
} from './endpoints';
import {
  ForgotPasswordRequest,
  LoginError,
  LoginRequest,
  LoginResponse,
  LogoutRequest,
  LogoutResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
} from './types';

const cookies = new Cookies();

export const useLogin = () =>
  useMutation<LoginResponse, LoginError, LoginRequest>((params) =>
    loginEndpoint.endpoint(params).then((res) => res.data),
  );

export const useForgotPassword = () =>
  useMutation<undefined, undefined, ForgotPasswordRequest>((params) =>
    forgotPasswordEndpoint.endpoint(params).then((res) => res.data),
  );

export const useResetPassword = () =>
  useMutation<ResetPasswordResponse, undefined, ResetPasswordRequest>(
    (params) => resetPasswordEndpoint.endpoint(params).then((res) => res.data),
  );

const useLogoutApi = () =>
  useMutation<LogoutResponse, undefined, LogoutRequest>((params) =>
    logoutEndpoint.endpoint(params).then((res) => res.data),
  );

export const useLogout = () => {
  const { mutate: setLogout, ...apiParams } = useLogoutApi();

  const redirect = () => {
    if (!window.location.pathname.includes('/accounts/login'))
      window.location = '/accounts/login' as unknown as Location;
  };

  const logout = () => {
    try {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('redirectStore');
      sessionStorage.removeItem('memberTabs');
      sessionStorage.removeItem('activeOffice');
      cookies.remove('officeId', { path: '/' });
      cookies.remove('beccascookie', { path: '/' });
      cookies.remove('userId', { path: '/' });
      cookies.remove('banner_hidden', { path: '/' });
      if (cookies.get('beccascookie')) {
        redirect();
      } else {
        setLogout(
          { userId: cookies.get('userId') },
          {
            onSuccess: () => redirect(),
            onError: (e) => {
              throw e;
            },
          },
        );
      }
    } catch (e) {
      console.log(e);
      redirect();
    }
  };
  return { logout, ...apiParams };
};
